import { Manager } from 'socket.io-client';

// Backend URL for API calls (relative to current domain)
export const backendUrl = window.location.origin;

// Socket.IO server URL (direct connection to avoid proxy issues)
const socketUrl = "https://repligo.forceai.jp";

// Socket.IO client setup
const manager = new Manager(socketUrl, {
  path: "/socket.io/",
  transports: ["polling", "websocket"],
  timeout: 999999,
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  forceNew: true
});

export const socket = manager.socket("/");

// Debug connection events
socket.on("connect", () => {
  // console.log("=== Socket.IO Connection Debug ===");
  // console.log("Socket connected:", socket.id);
  // console.log("Socket connected to:", socketUrl);
  // console.log("===========================");
  socket.emit("join", { sid: socket.id });
});

socket.on("connect_error", (error: Error) => {
  console.error("=== Socket.IO Connection Error ===");
  console.error("Error:", error);
  console.error("===========================");
});

socket.on("disconnect", (reason: string) => {
  console.log("=== Socket.IO Disconnection ===");
  console.log("Reason:", reason);
  console.log("===========================");
});

socket.on("error", (error: Error) => {
  console.error("=== Socket.IO Error ===");
  console.error("Error:", error);
  console.error("===========================");
});

// デバッグ用のイベントリスナー
// socket.on("progress_update", (data: unknown) => {
//   console.log("=== Socket.IO Event Debug ===");
//   console.log("Event: progress_update");
//   console.log("Data:", data);
//   console.log("===========================");
// });

// socket.on("scrape_complete", (data: unknown) => {
//   console.log("=== Socket.IO Event Debug ===");
//   console.log("Event: scrape_complete");
//   console.log("Data:", data);
//   console.log("===========================");
// });

// scrape_error イベントは GBP API 移行により削除

// Log initial connection attempt
// console.log("Attempting to connect to socket server...");
